import React, { useState } from 'react'

function formatRelative(ts) {
  const d = new Date(ts)
  const now = new Date()
  const diffMs = now - d
  const diffMin = Math.floor(diffMs / 60000)
  if (diffMin < 1) return 'just now'
  if (diffMin < 60) return `${diffMin}m ago`
  const diffHr = Math.floor(diffMin / 60)
  if (diffHr < 24) return `${diffHr}h ago`
  const diffDay = Math.floor(diffHr / 24)
  if (diffDay < 7) return `${diffDay}d ago`
  return d.toLocaleDateString()
}

export function TrackingSection({ tracking = [] }) {
  const [expanded, setExpanded] = useState(false)

  if (!tracking || tracking.length === 0) return null

  const sorted = [...tracking].reverse()

  return (
    <div style={styles.section}>
      <button style={styles.toggle} onClick={(e) => { e.stopPropagation(); setExpanded((v) => !v) }}>
        {expanded ? '\u25BE' : '\u25B8'} Tracking ({tracking.length})
      </button>
      {expanded && (
        <div style={styles.list}>
          {sorted.map((entry, i) => (
            <div key={i} style={styles.entry}>
              <span style={styles.timestamp}>{formatRelative(entry.timestamp)}</span>
              <span style={styles.description}>{entry.description}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

const styles = {
  section: { display: 'flex', flexDirection: 'column', gap: '4px' },
  toggle: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '11px',
    color: 'var(--text-secondary)',
    padding: 0,
    textAlign: 'left',
    fontWeight: 500,
  },
  list: { display: 'flex', flexDirection: 'column', gap: '2px', paddingLeft: '12px' },
  entry: { display: 'flex', gap: '8px', fontSize: '11px', lineHeight: 1.4 },
  timestamp: { color: 'var(--text-secondary)', whiteSpace: 'nowrap', flexShrink: 0 },
  description: { color: 'var(--text-primary)' },
}
